import {atom} from "recoil";
import {User} from "../../hooks/useServiceUsers";

const usersState = atom<User[]>({
  key: 'usersState',
  default: [],
});

export default usersState;